var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","id":"achievements"}},[_c('div',{attrs:{"id":"content"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('homepage.achievements.title')))]),_c('div',{staticClass:"pb-5",attrs:{"id":"timeline"}},[_c('TimelineComponent',{attrs:{"dark":true,"items":_vm.timelineItems}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }